<template>
  <div>
    <div>
      <img class="doctor_icon" alt="Vue logo" src="../assets/doctor_icon.jpeg">
    </div>
    <h5>体温を入力してください</h5>
    <b-container fluid>
      <b-row>
          <b-col  sm="10" offset-sm="1">
            <b-row>
              <b-col cols="2" />
              <b-col cols="4" >
                <b-form-select v-model="fever_integer_selected" :options="fever_integer"/>
              </b-col>
                <b-form-text>
                  <p style="font-size: 30px">
                    .
                  </p>
                </b-form-text>
              <b-col cols="4">
                <b-form-select v-model="fever_decimal_selected" :options="fever_decimal"/>
              </b-col>
              <b-col cols="2" />
            </b-row>
          </b-col>
        </b-row>
      </b-container>
      <b-row>
        <b-col>
          <b-form-text>
            <p style="font-size: 30px">
            {{fever_integer_selected}}.{{fever_decimal_selected}}&nbsp;&nbsp;&nbsp;℃
            </p>
          </b-form-text>
        </b-col>
      </b-row>
      <h5>症状がなければ<br>チェックを外してください</h5>
      <div>
        <b-form-group>
          <b-form-checkbox v-model="data.cough">
          咳はありますか？
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="data.breath_difficult">
          息苦しさなどの症状はありますか？
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="data.runny_nose">
          鼻水の症状はありますか？
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="data.headache">
          頭痛はありますか？
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="data.diarrtha">
          下痢の症状はありますか？
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="data.taste_disorder">
          味覚障害はありますか？
          </b-form-checkbox>
        </b-form-group>
        <b-container>
          <b-row class="mt-2"/>
          <h5>位置情報を取得できます(任意)</h5>
          <b-row>
            <b-col>
              <div style="justify-content: center;">
                <input id="input" v-model="data.postal_code" readonly="readonly" style="width:120px !important;"/>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <b-container>
          <b-row class="mt-2">
            <b-col xs="2"/>
            <b-col xs="4">
              <b-button variant="outline-danger" @click="deleteGetArea()" style="margin-bottom: 30px">削除</b-button>
            </b-col>
            <b-col xs="4">
              <b-button variant="outline-success" v-on:click="runGetArea()" style="margin-bottom: 30px;">取得</b-button>
            </b-col>
            <b-col xs="2"/>
        </b-row>
        </b-container>
        <b-button variant="success" v-on:click="getDataBase()"  class="mt-2 mb-4">送信</b-button>
    </div>
  </div>
</template>

<script type="text/javascript"
    src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDzrz5Pe0VpxzPOS0ViXgboVoANITQefeY">
</script>

<script>
import 'firebase/functions'
import firebase from 'firebase'

// initializeAppはHomeでする

const REGION_TOKYO = 'asia-northeast1'

export default {
  data () {
    return {
      data: this.$store.state.userData,
      fever_integer_selected: '--',
      fever_decimal_selected: '-',
      features: [],
      fever_integer: [
        { value: '--', text: '選択' },
        { value: '34', text: '34' },
        { value: '35', text: '35' },
        { value: '36', text: '36' },
        { value: '37', text: '37' },
        { value: '38', text: '38' },
        { value: '39', text: '39' },
        { value: '40', text: '40' },
        { value: '41', text: '41' },
        { value: '42', text: '42' }
      ],
      fever_decimal: [
        { value: '-', text: '選択' },
        { value: '0', text: '0' },
        { value: '1', text: '1' },
        { value: '2', text: '2' },
        { value: '3', text: '3' },
        { value: '4', text: '4' },
        { value: '5', text: '5' },
        { value: '6', text: '6' },
        { value: '7', text: '7' },
        { value: '8', text: '8' },
        { value: '9', text: '9' }
      ]
    }
  },
  created () {
    this.data.user_info = this.$store.state.loginData
    this.data.postal_code = "未入力"
  },
  mounted () {
    this.deleteGetArea()
  },
  methods: {
    deleteGetArea: function() {
      document.getElementById('input').value = "未入力"
    },
    runGetArea: function () {
      navigator.geolocation.getCurrentPosition(this.getArea)
    },
  getArea: (position) => {
    document.getElementById('input').value = "取得中…"
 //緯度・経度をLatLngクラスに変換します。
  var latLngInput = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
  var geocoder = new google.maps.Geocoder();
  //第１引数のリクエストパラメータにlatLngプロパティを設定します。
  //第２引数はコールバック関数です。取得結果を処理します。
  geocoder.geocode(
    {
      latLng: latLngInput
    },
    (results, status) => {
      var address = "";
      if (status == google.maps.GeocoderStatus.OK) {
      //取得が成功した場合
        //住所を取得します。
        address = results[0].formatted_address;
      } else if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
        alert("住所が見つかりませんでした。");
      } else if (status == google.maps.GeocoderStatus.ERROR) {
        alert("サーバ接続に失敗しました。");
      } else if (status == google.maps.GeocoderStatus.INVALID_REQUEST) {
        alert("リクエストが無効でした。");
      } else if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
        alert("リクエストの制限回数を超えました。");
      } else if (status == google.maps.GeocoderStatus.REQUEST_DENIED) {
        alert("サービスが使えない状態でした。");
      } else if (status == google.maps.GeocoderStatus.UNKNOWN_ERROR) {
        alert("原因不明のエラーが発生しました。");
      }
      document.getElementById('input').value = address.substr(13,3)
    })

    },
    async getDataBase () {
      // 体温未入力の際のバリデーション
      if (this.fever_integer_selected === '--' || this.fever_decimal_selected === '-') {
        alert('体温が入力されてません。\n入力画面よりご確認ください。')
        return
      }
      // 症状を確認して features に格納
      var searchValue = [this.data.cough, this.data.breath_difficult, this.data.runny_nose, this.data.headache, this.data.diarrtha]
      var searchKey = ['せき', '息苦しさ', '鼻水', '頭痛', '下痢','味覚障害']
      for (var i = 0; i < searchValue.length; i++) {
        if (searchValue[i] === true) {
          this.features.push(searchKey[i])
        }
      }
      this.data.fever = this.fever_integer_selected + '.' + this.fever_decimal_selected
      this.data.postal_code = document.getElementById('input').value // エリアの代入
      // 送信前の最終確認
      var checked = window.confirm(`以下の内容で送信しますか？\n体温:${this.data.fever}\n症状:${this.features}\nエリア:${this.data.postal_code}`)
      if (checked === false) {
        this.features = []
        return
      }
      const getDataBase = firebase.app()
        .functions(REGION_TOKYO) // Functionsのデプロイされているregion指定
        .httpsCallable(process.env.VUE_APP_ADD_DATA_BASE) // Functionsの関数名指定
      try {
        var data = this.data
        console.log(data.postal_code)
        alert('送信しました！\nHome 画面よりご確認ください。')
        this.$store.dispatch('setResultData', null)
        this.$router.push('/')
        await getDataBase(data)
        this.$store.dispatch('setLateRead', true)
      } catch (e) {
        const errorMessage = e
        throw errorMessage
      }
    }
  }
}
</script>

<style scoped lang="scss">

h3 {
  margin: 40px 0 0;
}

h5 {
  margin: 20px 0 20px 0
}

.doctor_icon {
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
}

</style>
